import { Suspense } from "react";
import { useSelector } from "react-redux";
import { ModuleRatingsContextProvider } from "./module-ratings.context";
import { ModuleRatingsTableFilters } from "./parts/filters";
import { ModuleRatingsTable } from "./parts/table/module-ratings-table.component";
import { Permission } from "../../../__generated__/MainNavigation_Query.graphql";
import { selectHasPermissions } from "../../../infecto-lms-admin/redux/slices/CurrentUserSlice";
import { ReduxState } from "../../../infecto-lms-admin/redux/Store";
import { BaseScreen } from "../../../infecto-lms-admin/screens/BaseScreen";

export const ModuleRatingsScreen = () => {
	const isAdmin = useCheckPermission([
		"AccountPermission_System_Root",
		"UserInAccountPermission_System_Owner",
	]);

	if (!isAdmin) {
		return <div>Kein Zugriff</div>;
	}

	return (
		<BaseScreen>
			<h1>Modul-Bewertungen</h1>
			<ModuleRatingsContextProvider>
				<div className={"flex flex-column gap-2"}>
					<ModuleRatingsTableFilters />
					<Suspense fallback={<div>Lade...</div>}>
						<ModuleRatingsTable />
					</Suspense>
				</div>
			</ModuleRatingsContextProvider>
		</BaseScreen>
	);
};

const useCheckPermission = (permissions: Permission[]) =>
	useSelector((state: ReduxState) => selectHasPermissions(state, permissions));
